import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "career-page" }
const _hoisted_2 = { class: "career-hero" }
const _hoisted_3 = { class: "career-container career-hero-content" }
const _hoisted_4 = { class: "career-tags" }
const _hoisted_5 = { class: "career-section benefits-section" }
const _hoisted_6 = { class: "career-container" }
const _hoisted_7 = { class: "career-benefits" }
const _hoisted_8 = { class: "career-section jobs-section" }
const _hoisted_9 = { class: "career-container" }
const _hoisted_10 = { class: "job-list-card" }
const _hoisted_11 = { class: "job-main" }
const _hoisted_12 = { class: "job-action" }
const _hoisted_13 = { class: "job-pills" }
const _hoisted_14 = {
  class: "application-modal",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "application-title"
}
const _hoisted_15 = {
  key: 0,
  class: "application-success"
}
const _hoisted_16 = { class: "field-row" }
const _hoisted_17 = { class: "field-row" }
const _hoisted_18 = { class: "upload-grid" }
const _hoisted_19 = { class: "upload-card" }
const _hoisted_20 = { class: "upload-card" }
const _hoisted_21 = { class: "privacy-check" }
const _hoisted_22 = {
  key: 0,
  class: "form-error"
}
const _hoisted_23 = ["disabled"]

import {ref} from 'vue';
import axios from 'axios';
import {
  ArrowRight,
  BriefcaseMedical,
  Check,
  CheckCircle2,
  Clock3,
  FileText,
  HeartHandshake,
  Send,
  Stethoscope,
  Upload,
  X
} from 'lucide-vue-next';
import '@/assets/styles/career.css';

const assistantPosition = 'Assistenz der Geschäftsführung und Pflegeleitung (m/w/d)';


export default /*@__PURE__*/_defineComponent({
  __name: 'CareerView',
  setup(__props) {

const form = ref({
  name: '',
  forename: '',
  email: '',
  number: '',
  position: assistantPosition,
  resume: null as File | null,
  cover: null as File | null,
  data: false
});

const showForm = ref(false);
const sending = ref(false);
const submitted = ref(false);
const error = ref('');

const handleFileUpload = (event: Event, type: 'resume' | 'cover') => {
  const target = event.target as HTMLInputElement;
  form.value[type] = target.files?.[0] ?? null;
};

const openForm = () => {
  showForm.value = true;
  submitted.value = false;
  error.value = '';
};

const closeForm = () => {
  showForm.value = false;
  submitted.value = false;
  error.value = '';
};

const resetForm = () => {
  form.value = {
    name: '',
    forename: '',
    email: '',
    number: '',
    position: assistantPosition,
    resume: null,
    cover: null,
    data: false
  };
};

const submitForm = async () => {
  sending.value = true;
  error.value = '';

  try {
    const formData = new FormData();
    formData.append('name', form.value.name);
    formData.append('forename', form.value.forename);
    formData.append('email', form.value.email);
    formData.append('number', form.value.number);
    formData.append('position', form.value.position);

    if (form.value.resume) formData.append('resume', form.value.resume);
    if (form.value.cover) formData.append('cover', form.value.cover);

    await axios.post('/api/application', formData);
    submitted.value = true;
    resetForm();
  } catch {
    error.value = 'Die Bewerbung konnte nicht gesendet werden. Bitte versuchen Sie es erneut.';
  } finally {
    sending.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "career-eyebrow" }, "Karriere beim Gallus Pflegedienst", -1)),
        _cache[11] || (_cache[11] = _createElementVNode("h1", null, [
          _createTextVNode("Gemeinsam für Menschen."),
          _createElementVNode("br"),
          _createElementVNode("em", null, "Mit Herz und Verantwortung.")
        ], -1)),
        _cache[12] || (_cache[12] = _createElementVNode("p", null, " Bei uns verbinden sich fachliche Qualität, menschliche Nähe und ein starkes Miteinander. Entdecken Sie Ihre beruflichen Möglichkeiten beim Gallus Pflegedienst. ", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, [
            _createVNode(_unref(Check)),
            _cache[7] || (_cache[7] = _createTextVNode(" Ambulante Pflege", -1))
          ]),
          _createElementVNode("span", null, [
            _createVNode(_unref(Check)),
            _cache[8] || (_cache[8] = _createTextVNode(" Wertschätzendes Team", -1))
          ]),
          _createElementVNode("span", null, [
            _createVNode(_unref(Check)),
            _cache[9] || (_cache[9] = _createTextVNode(" Frankfurt am Main", -1))
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "career-section-heading" }, [
          _createElementVNode("div", null, [
            _createElementVNode("span", { class: "career-eyebrow" }, "Das erwartet Sie"),
            _createElementVNode("h2", null, [
              _createTextVNode("Ein Arbeitsplatz,"),
              _createElementVNode("br"),
              _createTextVNode("an dem Sie zählen.")
            ])
          ]),
          _createElementVNode("p", null, " Wir arbeiten engagiert für die Menschen, die uns vertrauen. Dabei setzen wir auf Fachkompetenz, gegenseitige Unterstützung und eine offene Kommunikation. ")
        ], -1)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("article", null, [
            _createVNode(_unref(HeartHandshake)),
            _cache[13] || (_cache[13] = _createElementVNode("h3", null, "Persönliches Miteinander", -1)),
            _cache[14] || (_cache[14] = _createElementVNode("p", null, "Kurze Wege, direkte Abstimmung und ein wertschätzender Umgang im Team.", -1))
          ]),
          _createElementVNode("article", null, [
            _createVNode(_unref(BriefcaseMedical)),
            _cache[15] || (_cache[15] = _createElementVNode("h3", null, "Sinnvolle Arbeit", -1)),
            _cache[16] || (_cache[16] = _createElementVNode("p", null, "Mit Ihrer Arbeit leisten Sie jeden Tag einen wichtigen Beitrag für andere Menschen.", -1))
          ]),
          _createElementVNode("article", null, [
            _createVNode(_unref(Stethoscope)),
            _cache[17] || (_cache[17] = _createElementVNode("h3", null, "Professionelles Umfeld", -1)),
            _cache[18] || (_cache[18] = _createElementVNode("p", null, "Klare Abläufe und fachlicher Austausch bilden die Grundlage unserer Arbeit.", -1))
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _cache[31] || (_cache[31] = _createElementVNode("div", { class: "jobs-heading" }, [
          _createElementVNode("span", { class: "career-eyebrow" }, "Offene Stelle"),
          _createElementVNode("h2", null, "Vielleicht passen wir zusammen."),
          _createElementVNode("p", null, "Für den ersten Schritt reichen wenige Angaben. Ihre Unterlagen können Sie direkt hochladen.")
        ], -1)),
        _createElementVNode("article", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[23] || (_cache[23] = _createElementVNode("span", { class: "job-status" }, "Aktuell gesucht", -1)),
            _cache[24] || (_cache[24] = _createElementVNode("h3", null, [
              _createTextVNode("Assistenz der Geschäftsführung und Pflegeleitung "),
              _createElementVNode("small", null, "(m/w/d)")
            ], -1)),
            _cache[25] || (_cache[25] = _createElementVNode("p", null, " Wir suchen in Teilzeit oder geringfügiger Beschäftigung eine zuverlässige, strukturierte Persönlichkeit, die unsere Geschäftsführung und Pflegeleitung organisatorisch unterstützt. Die Arbeitszeiten und Arbeitstage werden flexibel miteinander abgestimmt. ", -1)),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createVNode(_unref(Check)),
                _cache[20] || (_cache[20] = _createTextVNode(" Pflegerischer oder medizinischer Hintergrund", -1))
              ]),
              _createElementVNode("li", null, [
                _createVNode(_unref(Check)),
                _cache[21] || (_cache[21] = _createTextVNode(" Strukturierte und zuverlässige Arbeitsweise", -1))
              ]),
              _createElementVNode("li", null, [
                _createVNode(_unref(Check)),
                _cache[22] || (_cache[22] = _createTextVNode(" Organisationstalent und freundliche Kommunikation", -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", null, [
                _createVNode(_unref(Clock3)),
                _cache[26] || (_cache[26] = _createTextVNode(" Teilzeit oder geringfügig", -1))
              ]),
              _createElementVNode("span", null, [
                _createVNode(_unref(Clock3)),
                _cache[27] || (_cache[27] = _createTextVNode(" 9–12 Std./Woche", -1))
              ]),
              _createElementVNode("span", null, [
                _createVNode(_unref(Check)),
                _cache[28] || (_cache[28] = _createTextVNode(" Variable Tage nach Absprache", -1))
              ]),
              _createElementVNode("span", null, [
                _createVNode(_unref(Stethoscope)),
                _cache[29] || (_cache[29] = _createTextVNode(" Pflege & Medizin", -1))
              ])
            ]),
            _createElementVNode("button", {
              class: "career-button",
              type: "button",
              onClick: openForm
            }, [
              _cache[30] || (_cache[30] = _createTextVNode(" Jetzt bewerben ", -1)),
              _createVNode(_unref(ArrowRight))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "career-modal" }, {
      default: _withCtx(() => [
        (showForm.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "application-overlay",
              onClick: _withModifiers(closeForm, ["self"])
            }, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  class: "modal-close",
                  type: "button",
                  "aria-label": "Bewerbungsformular schließen",
                  onClick: closeForm
                }, [
                  _createVNode(_unref(X))
                ]),
                (submitted.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_unref(CheckCircle2)),
                      _cache[32] || (_cache[32] = _createElementVNode("h2", null, "Vielen Dank!", -1)),
                      _cache[33] || (_cache[33] = _createElementVNode("p", null, "Ihre Bewerbung wurde erfolgreich übermittelt. Wir melden uns persönlich bei Ihnen.", -1)),
                      _createElementVNode("button", {
                        class: "career-button",
                        type: "button",
                        onClick: closeForm
                      }, "Schließen")
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", { class: "modal-heading" }, [
                        _cache[34] || (_cache[34] = _createElementVNode("span", { class: "career-eyebrow" }, "Direkt bewerben", -1)),
                        _cache[35] || (_cache[35] = _createElementVNode("h2", { id: "application-title" }, "Wir freuen uns auf Sie.", -1)),
                        _createElementVNode("p", null, _toDisplayString(assistantPosition))
                      ]),
                      _createElementVNode("form", {
                        class: "application-form",
                        onSubmit: _withModifiers(submitForm, ["prevent"])
                      }, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("label", null, [
                            _cache[36] || (_cache[36] = _createElementVNode("span", null, "Vorname *", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.forename) = $event)),
                              required: "",
                              autocomplete: "given-name",
                              placeholder: "Max"
                            }, null, 512), [
                              [_vModelText, form.value.forename]
                            ])
                          ]),
                          _createElementVNode("label", null, [
                            _cache[37] || (_cache[37] = _createElementVNode("span", null, "Nachname *", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.name) = $event)),
                              required: "",
                              autocomplete: "family-name",
                              placeholder: "Mustermann"
                            }, null, 512), [
                              [_vModelText, form.value.name]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("label", null, [
                            _cache[38] || (_cache[38] = _createElementVNode("span", null, "E-Mail *", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.email) = $event)),
                              required: "",
                              type: "email",
                              autocomplete: "email",
                              placeholder: "mail@beispiel.de"
                            }, null, 512), [
                              [_vModelText, form.value.email]
                            ])
                          ]),
                          _createElementVNode("label", null, [
                            _cache[39] || (_cache[39] = _createElementVNode("span", null, "Telefon *", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.number) = $event)),
                              required: "",
                              type: "tel",
                              autocomplete: "tel",
                              placeholder: "+49 …"
                            }, null, 512), [
                              [_vModelText, form.value.number]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("label", _hoisted_19, [
                            _createElementVNode("input", {
                              type: "file",
                              accept: "application/pdf,.pdf",
                              onChange: _cache[4] || (_cache[4] = ($event: any) => (handleFileUpload($event, 'resume')))
                            }, null, 32),
                            _createVNode(_unref(Upload)),
                            _createElementVNode("span", null, [
                              _cache[40] || (_cache[40] = _createElementVNode("strong", null, "Lebenslauf hochladen", -1)),
                              _createElementVNode("small", null, _toDisplayString(form.value.resume ? form.value.resume.name : 'PDF auswählen (optional)'), 1)
                            ])
                          ]),
                          _createElementVNode("label", _hoisted_20, [
                            _createElementVNode("input", {
                              type: "file",
                              accept: "application/pdf,.pdf",
                              onChange: _cache[5] || (_cache[5] = ($event: any) => (handleFileUpload($event, 'cover')))
                            }, null, 32),
                            _createVNode(_unref(FileText)),
                            _createElementVNode("span", null, [
                              _cache[41] || (_cache[41] = _createElementVNode("strong", null, "Anschreiben hochladen", -1)),
                              _createElementVNode("small", null, _toDisplayString(form.value.cover ? form.value.cover.name : 'PDF auswählen (optional)'), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("label", _hoisted_21, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.data) = $event)),
                            required: "",
                            type: "checkbox"
                          }, null, 512), [
                            [_vModelCheckbox, form.value.data]
                          ]),
                          _createElementVNode("span", null, [
                            _cache[43] || (_cache[43] = _createTextVNode(" Ich stimme der Verarbeitung meiner Bewerbungsdaten gemäß ", -1)),
                            _createVNode(_component_router_link, {
                              to: "/datenschutz",
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                _createTextVNode("Datenschutzerklärung", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[44] || (_cache[44] = _createTextVNode(" zu. ", -1))
                          ])
                        ]),
                        (error.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(error.value), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          class: "career-button submit-application",
                          disabled: sending.value
                        }, [
                          _createVNode(_unref(Send)),
                          _createTextVNode(" " + _toDisplayString(sending.value ? 'Wird übermittelt …' : 'Bewerbung senden'), 1)
                        ], 8, _hoisted_23)
                      ], 32)
                    ], 64))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})